import { authRedirectRoute, Guard } from '@if/mui'
import { access } from '@src/access'
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'
import BrowseCreditApplicationPage from '../BrowseCreditApplicationPage'
import CalculatorPage from '../CalculatorPage'
import ChatDashboardPage from '../ChatDashboardPage'
import ChatPage from '../ChatPage'
import WorksheetWrapper from '../CreateWorksheetPage/WorksheetWrapper'
import CreateCreditApplicationPage from '../CreditApplicationPage/CreateCreditApplicationPage'
import EditCreditApplicationPage from '../CreditApplicationPage/EditCreditApplicationPage'
import CustomBuydownPage from '../CustomBuydownPage'
import FundingSummary from '../FundingSummary'
import HomePage from '../HomePage'
import ManageUsersPage from '../ManageUsersPage'
import ProtectionPlanPage from '../ProtectionPlanPage'
import StatisticsPage from '../StatisticsPage'
import ViewCreditApplicationPage from '../ViewCreditApplicationPage'
import DashboardShell from './DashboardShell'
import { useMerchant } from './MerchantProvider'

const CustomBuydownRoute = () => {
  const merchant = useMerchant()
  return (
    <Guard {...access.customBuydown} resources={{ merchant }}>
      <CustomBuydownPage />
    </Guard>
  )
}

const MerchantStatisticsRoute = () => {
  const merchant = useMerchant()
  return (
    <Guard {...access.merchantStatistics} resources={{ merchant }}>
      <StatisticsPage />
    </Guard>
  )
}

const ProtectionPlanRoute = () => {
  const merchant = useMerchant()
  return (
    <Guard {...access.protectionPlan} resources={{ merchant }}>
      <ProtectionPlanPage />
    </Guard>
  )
}

export const router = createBrowserRouter([
  {
    element: <DashboardShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'loan-calculator', element: <CalculatorPage /> },
      { path: 'protection-plan', element: <ProtectionPlanRoute /> },
      {
        path: 'credits',
        children: [
          { index: true, element: <BrowseCreditApplicationPage /> },
          {
            path: ':financingProgramId',
            children: [
              {
                path: 'add',
                element: (
                  <Guard {...access.createApplication}>
                    <CreateCreditApplicationPage />
                  </Guard>
                ),
              },
              {
                path: ':id',
                element: (
                  <Guard {...access.applicationDetail}>
                    <Outlet />
                  </Guard>
                ),
                children: [
                  { index: true, element: <ViewCreditApplicationPage /> },
                  { path: 'edit', element: <EditCreditApplicationPage /> },
                  { path: 'worksheet', element: <WorksheetWrapper /> },
                  { path: 'funding-summary', element: <FundingSummary /> },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'manage-users',
        element: (
          <Guard {...access.manageUsers}>
            <ManageUsersPage />
          </Guard>
        ),
      },
      {
        path: 'custom-buydown',
        element: <CustomBuydownRoute />,
      },
      {
        path: 'merchant-statistics',
        element: <MerchantStatisticsRoute />,
      },

      {
        path: 'chat-dashboard',
        element: (
          <Guard {...access.messaging}>
            <Outlet />
          </Guard>
        ),
        children: [
          { index: true, element: <ChatDashboardPage /> },
          { path: ':financingProgramId/:creditApplicationId', element: <ChatPage /> },
        ],
      },
      authRedirectRoute,
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
